import {
    axios
} from '@/utils/request'

/**
 * index func
 * @param parameter
 * @returns {*}
 */
//获取直播聊天室信息
export function apiGetLiveChat(parameter) {
    return axios({
        url: '/course/chat/getChatParams',
        method: 'post',
        data: parameter
    })
}